import { createBrowserRouter } from "react-router-dom";

import Login from "../pages/Login/Login"
import Votes from "../pages/Votes/Votes"
import Protected from "../components/Protected";
import Ballot from "../pages/Ballot/Ballot";
import UserManagement from "../pages/UserManagement/UserManagement";
import Vote from "../pages/Vote/Vote";
import CreateVote from "../pages/CreateVote/CreateVote";
import Developer from "../pages/Developer/Developer";
import VoteHistory from "../pages/VoteHistory/VoteHistory";
import Handrules from "../pages/Handrules/Handrules"
import Profile from "../pages/Profile/Profile";

const router = createBrowserRouter([
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "",
        element: <Protected> <Votes /> </Protected>
    },
    {
        path: "/",
        element: <Protected> <Votes /> </Protected>
    },
    {
        path: "/ballot/:ballotId",
        element: <Protected> <Ballot /> </Protected>
    },
    // {
    //     path: "/admin",
    //     element: <Protected> <AdminRoutes /> </Protected>
    // },
    {
        path: "/usermanagement",
        element: <Protected> <UserManagement /> </Protected>
    },
    {
        path: "/vote",
        element: <Protected> <Vote /> </Protected>
    },
    {
        path: "/createvote",
        element: <Protected> <CreateVote /> </Protected>
    },
    {
        path: "/developer",
        element: <Protected> <Developer /> </Protected>
    },
    {
        path: "/voteHistory",
        element: <Protected> <VoteHistory /> </Protected>
    },
    {
        path: "/handrules",
        element: <Protected> <Handrules /> </Protected>
    },
    {
        path: "/profile",
        element: <Protected> <Profile /> </Protected>
    }
]);

export default router;